// Anything the index does not keep inside a word. It breaks a tag on these,
// so a query has to break on them too or it asks for a word that was never
// stored.
const WORD_SEPARATOR = /[^\p{L}\p{N}]+/u;

/**
 * Splits what the recruiter typed into the words the catalog is searched by.
 *
 * Lowercased because the index stores each word lowercased, and a wildcard is
 * compared against the stored form rather than analysed first, so `Smith` would
 * miss `smith`.
 *
 * Split on punctuation as well as spaces, because the index splits there too:
 * `Candidate ID:TEST-00010` is stored as `candidate`, `id:test` and `00010`, so
 * searching the id as it is displayed finds nothing unless the hyphen breaks
 * the query as well. Since every word has to match and a wildcard matches
 * inside a word, splitting more finely only ever widens what can be found.
 */
export const normaliseTagQuery = (query: string): string[] =>
  query.toLowerCase().split(WORD_SEPARATOR).filter(Boolean);
